var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ve-tree",staticStyle:{"height":"calc(100vh - 1.30208vw)"}},[_c('vue-easy-tree',{ref:"veTree",attrs:{"node-key":"id","show-checkbox":"","height":"6.51042vw","data":_vm.treeData,"props":_vm.props}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }